import React from 'react';
import './index.scss';
import { formatBytes } from '../../util/utils';

function identifyPattern(filename) {
  const prefix = /^[a-f\d]{24}-[a-f\d]{24}-/;
  const suffix = /-\d+-\d+\.[a-z]{3,4}$/i;
  if (typeof filename !== 'string' || filename.length < 60) {
    return false;
  }
  const trimmed = filename.slice(48, -16);
  return prefix.test(filename) && suffix.test(filename) && trimmed.length > 0;
}

export default function DocumentMessage(props) {
  const imagesIcons = {
    PDF: 'document_pdf',
    DOC: 'document_doc',
    DOCX: 'document_doc',
    PPT: 'document_ppt',
    PPTX: 'document_ppt',
    TXT: 'document_txt',
    CSV: 'document_doc',
    XLS: 'document_sheet',
    XLSX: 'document_sheet',
    ZIP: 'document_compact',
    RAR: 'document_compact',
    '7Z': 'document_compact',
    GZ: 'document_compact',
  };

  if (props.message.from === 'BOT') {
    // DOCUMENT CARD FROM BOT IN PREVIEW AND WEBCHAT FULLSCREN

    const { fileUrl } = props.message.document;
    const { secondaryColor, divId } = props;

    const result = fileUrl.split('/')[fileUrl.split('/').length - 1];
    const infoArray = result.split('-');
    const ext = infoArray[infoArray.length - 1].split('.')[1];
    const formatBytesOutput = formatBytes(infoArray[infoArray.length - 2], 0);

    const filename = fileUrl.substring(fileUrl.lastIndexOf('/') + 1);

    const name = identifyPattern(filename)
      ? `${infoArray.slice(2, -2).join('-')}.${ext}`
      : filename;
    const size = formatBytesOutput ? `- ${formatBytesOutput}` : '';
    const extUpper = ext.toUpperCase();

    return (
      <div
        id={divId}
        className="document-message doc-from-bot"
        style={{ backgroundColor: secondaryColor }}
      >
        <div className="doc-from-bot-content">
          <span className="code7-boteria__accessibility-item">
            {` extensão ${extUpper} ${
              identifyPattern(filename) ? `e tamanho ${size}` : ''
            }`}
            {`Para baixá-lo acesse o link abaixo ou Ícone para download do arquivo`}
          </span>
          <a
            className="img-fluid container-document-preview"
            href={fileUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={`/assets/images/icons/${imagesIcons[extUpper]}.svg`}
              className="img-fluid"
              alt=""
            />
            <div className="document-text-info">
              <div className="document-title">{name}</div>
              <div className="format-size">{`${extUpper || ''} ${
                identifyPattern(filename) ? size : ''
              }`}</div>
            </div>
            <div className="download-icon-container">
              <img
                src="/assets/images/icons/document-download.svg"
                className="download-icon"
                alt="Ícone para download do arquivo"
              />
            </div>
          </a>
        </div>
      </div>
    );
  }
  if (props.channel === 'preview') {
    // DOCUMENT CARD FROM USER IN PREVIEW

    const info = props.message;
    const { mainColor, divId } = props;
    const { name } = info.properties;
    const formatBytesOutput = formatBytes(info.properties.size, 0);
    const size = formatBytesOutput ? `- ${formatBytesOutput}` : '';
    const extUpper = info.properties.ext.toUpperCase();

    return (
      <div
        id={divId}
        className="document-message doc-from-user"
        style={{ backgroundColor: mainColor }}
      >
        <div className="doc-from-user-content">
          <span className="code7-boteria__accessibility-item">
            {` extensão ${extUpper} e tamanho ${size}`}
            {`Para baixá-lo acesse o link abaixo ou Ícone para download do arquivo`}
          </span>
          <a
            download={name}
            className="img-fluid container-document-preview"
            href={info.message}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={`/assets/images/icons/${imagesIcons[extUpper]}.svg`}
              className="img-fluid"
              alt="doc"
            />
            <div className="document-text-info">
              <div className="document-title">{name}</div>
              <div className="format-size">{`${extUpper} ${size}`}</div>
            </div>
            <div className="download-icon-container">
              <img
                src="/assets/images/icons/document-download.svg"
                className="download-icon"
                alt="Ícone para download do arquivo"
              />
            </div>
          </a>
        </div>
      </div>
    );
  }
  // DOCUMENT CARD FROM USER IN WEBCHAT FULLSCREEN

  const info = props.message;
  const { name } = info.properties;
  const { mainColor, divId } = props;
  const formatBytesOutput = formatBytes(info.properties.size, 0);
  const size = formatBytesOutput ? `- ${formatBytesOutput}` : '';
  const extUpper = info.properties.ext.toUpperCase();

  return (
    <li className="webchat-body-chat-messages-user mb-3">
      <div
        id={divId}
        className="document-message doc-from-user"
        style={{ backgroundColor: mainColor }}
      >
        <div className="doc-from-user-content">
          <span className="code7-boteria__accessibility-item">
            {` extensão ${extUpper} e tamanho ${size}`}
            {`Para baixá-lo acesse o link abaixo ou Ícone para download do arquivo`}
          </span>
          <a
            download={name}
            className="img-fluid container-document-preview"
            href={info.message}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={`/assets/images/icons/${imagesIcons[extUpper]}.svg`}
              className="img-fluid"
              alt=""
            />
            <div className="document-text-info">
              <div className="document-title">{name}</div>
              <div className="format-size">{`${extUpper} ${size}`}</div>
            </div>
            <div className="download-icon-container">
              <img
                src="/assets/images/icons/document-download.svg"
                className="download-icon"
                alt="Ícone para download do arquivo"
              />
            </div>
          </a>
        </div>
      </div>
    </li>
  );
}
